import React from 'react';

import Basic, { ShowcaseTemplateProps } from '../Basic';

import classes from './BlueberryCream.module.scss'

export default function BlueberryCream({ showcase, offers, linksByOfferId }: ShowcaseTemplateProps): JSX.Element {
  return (
    <Basic showcase={showcase} offers={offers} linksByOfferId={linksByOfferId} classes={classes} />
  );
}
